import { ReactNode } from 'react';
import { Box } from '@mui/material';

export interface CalendarWithToolbarLayoutProps {
  toolbar: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}

const CalendarWithToolbarLayout = ({ toolbar, children, footer }: CalendarWithToolbarLayoutProps) => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: 0,
      overflow: 'hidden',
    }}
  >
    <Box
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 2,
        flexShrink: 0,
        backgroundColor: 'background.paper',
      }}
    >
      {toolbar}
    </Box>
    <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>{children}</Box>
    {footer}
  </Box>
);

export default CalendarWithToolbarLayout;
